import React, { useState, useEffect, useRef } from "react"
import Divider from '@mui/material/Divider';
import { useAuthProfile } from "../../app/hooks"
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import { IconButton, Link } from '@mui/material';
//import SearchIcon from '@mui/icons-material/Search';
import { useLazyGetSearchResultsQuery, useGetMiniSearchQuery, useLazyGetLatestNewsQuery } from '../../features/resourcesSlice'
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
//import Markdown from 'react-markdown'
import { Alert, Button, Box, Stack, Skeleton, ListItemButton, ListItem, ListItemText, Typography } from '@mui/material';
//import  LoadingButton  from '@mui/material/Button';
//import ContentCopyIcon from '@mui/icons-material/ContentCopy';
//import Snackbar from '@mui/material/Snackbar';
//import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
//import { StartChat } from "../markers/MMMarkers";
import { useNavigate } from "react-router-dom";
import ArrowCircleRightRoundedIcon from '@mui/icons-material/ArrowCircleRightRounded';
import { cleanText } from "./ResourceLanding";
import { CopyToClipboardButton, MarkedDown, ResourceChatButton } from './ResourceResults'
import { coonditionContext, Condition, capitalizeWords } from '../../index'
import { useAuth } from "react-oidc-context";



export const ResourceMini = ({ hideTitle = false, noInnerScroll = false }: { hideTitle?: boolean; noInnerScroll?: boolean }) => {
  const { condition, baseName } = React.useContext<Condition>(coonditionContext);
  const auth = useAuth()
  // Initialization
  const dispatch = useDispatch()
  const { authStatus, profile, isLoading: isAuthProfileLoading, isSuccess, isError, error /*, userAttributesStateStatus */ } = useAuthProfile()
  const [searchText, setSearchText] = useState({ cleanText: '', validateText: '' })
  //const { data:miniSearchResult, isLoading: miniSearchResultLoading } = useGetMiniSearchQuery()
  const [getLatestNews, { data: latestNewsResult, isLoading: latestNewsLoading, isSuccess: latestNewsSuccess, isError: latestNewsError }] = useLazyGetLatestNewsQuery()
  const navigate = useNavigate()


  // Event Handling
  // Handle search via URL paramters

  useEffect(() => {
    if (profile) {
      let query = `Latest treatment developments, science and research on ${condition} as of `
      let currentDate = new Date()
      let day = currentDate.getDate();
      let month = currentDate.getMonth() + 1;
      let year = currentDate.getFullYear();
      let date = `${month}-${day}-${year}`;
      query = query + date.toString()
      getLatestNews({ query: query, profile_id: profile.id }, true)//.preferCacheValue?: boolean // { forceRefetch: true })
      setSearchText({ cleanText: query, validateText: query })
    }
  }, [profile])


  // Root function to handle dispatch of search
  function handleSubmit(e: any) {
    if (e)
      e.preventDefault();
    navigate("/resources?search=" + encodeURIComponent(searchText.cleanText))
  }


  // Rendering
  if (profile) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
        {!hideTitle && <Typography variant="overline" sx={{ color: '#9E9E9E', letterSpacing: 1.2, fontSize: 11, fontWeight: 600 }}>
          Latest News
        </Typography>}
        <Stack direction="column" justifyContent="flex-start" gap={2} sx={{ width: '100%', border: '1px solid', borderRadius: 3, p: 2, mt: 1, borderColor: 'rgba(164, 142, 233, 0.18)', backgroundColor: 'rgba(250, 250, 255, 0.45)', flex: 1, minHeight: 0 }}>
          <Paper
            elevation={0}
            sx={{
              display: 'flex',
              flexGrow: 2,
              width: '100%',
              backgroundColor: 'rgba(244, 244, 248, 0.55)',
              borderRadius: 2,
              pl: 2,
              justifyContent: 'space-between'
            }}
            component="form"
            onSubmit={handleSubmit}
          >
            <InputBase
              name="search"
              disabled={authStatus != "authenticated"}
              sx={{ flexGrow: 10, fontSize: 14 }}
              placeholder="Ask any question"
              value={searchText.cleanText}
              inputProps={{ 'aria-label': 'search resources' }}
              onChange={(e) => {
                setSearchText(cleanText(e.target.value));
              }}
            />
            <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
              <ArrowCircleRightRoundedIcon sx={{ color: '#656EFF' }} />
            </IconButton>
          </Paper>
          {authStatus != 'authenticated' &&
            <Link sx={{ cursor: 'pointer', textAlign: 'center' }} variant="subtitle2" onClick={() => navigate('/signin')}>
              Create a free account to use search
            </Link>
          }

          {latestNewsResult?.result
            ?
            <>
              <Box sx={noInnerScroll ? {} : { flex: 1, minHeight: 0, overflowY: 'auto', mx: -2, px: 2, '&::-webkit-scrollbar': { width: 6 }, '&::-webkit-scrollbar-track': { background: 'transparent' }, '&::-webkit-scrollbar-thumb': { background: 'rgba(164, 142, 233, 0.25)', borderRadius: 3, '&:hover': { background: 'rgba(164, 142, 233, 0.4)' } }, scrollbarWidth: 'thin', scrollbarColor: 'rgba(164, 142, 233, 0.25) transparent' }}>
                <MarkedDown searchText={searchText} searchResult={latestNewsResult} compact />
              </Box>
              <CopyToClipboardButton text={searchText.cleanText} getUrlString={(text) => {
                const href = window.location.href;
                return `${href}/Resources?search=${encodeURIComponent(text)};`
              }} />
            </>
            :
            <Skeleton animation="wave" variant="rectangular" width='100%' height={300} sx={{ borderRadius: 2 }} />
          }
        </Stack>
      </Box>
    )
  } else {
    return (
      <Skeleton animation="wave" variant="rectangular" width='100%' height={500} sx={{ borderRadius: 2 }} />
    )
  }

}